import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { PageShell } from "@/components/site-layout";
import { adminLogin } from "@/lib/api";
import Swal from 'sweetalert2';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    try {
      await adminLogin(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Invalid email or password.");
      setLoading(false);
      
      // Show error alert
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: 'Invalid email or password. Please try again.',
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK'
      });
    }
  };

  return (
    <PageShell>
      <section className="container-x flex min-h-[75vh] items-center justify-center py-16">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md rounded-3xl border border-border bg-card p-8 shadow-[var(--shadow-elegant)] animate-fade-up md:p-10"
        >
          <div className="grid h-14 w-14 place-items-center rounded-2xl bg-[image:var(--gradient-primary)] text-primary-foreground">
            <Lock className="h-6 w-6" />
          </div>
          <h1 className="mt-6 text-3xl font-bold">Admin sign in</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Review submitted applications and issue registration codes.
          </p>

          <label className="mt-8 block">
            <span className="mb-1.5 block text-sm font-medium">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@revocubelinks.com"
              className="w-full rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/20"
            />
          </label>

          <label className="mt-4 block">
            <span className="mb-1.5 block text-sm font-medium">Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/20"
            />
          </label>

          {error && <p className="mt-3 text-sm text-destructive">{error}</p>}

          <button type="submit" disabled={loading} className="btn-primary mt-6 w-full">
            {loading ? (
              <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</>
            ) : (
              <>Sign in <ArrowRight className="h-4 w-4" /></>
            )}
          </button>

          <p className="mt-6 rounded-xl bg-muted px-4 py-3 text-xs text-muted-foreground">
            Admin credentials — <span className="font-medium text-foreground">admin@revocubelinks.com</span> /{" "}
            <span className="font-medium text-foreground">admin123</span>
          </p>
        </form>
      </section>
    </PageShell>
  );
}
